import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'

import { Input } from '@/ui'
import classNames from 'classnames'

import styles from './index.less'

const { TextArea } = Input

export default forwardRef(({ labelText = '已选商品数', value = [], onChange, placeholder, classname }: any, ref) => {
    const [input, setInput] = useState('')

    useEffect(() => {
        setInput(value.join(','))
    }, [value])

    useImperativeHandle(ref, () => ({
        textAreaChange
    }))

    // 文本框更新，table选中要做选择
    const textAreaChange = (str: string) => {
        if (str) {
            const inputVal = str.replace(/\n+/g, ',').replace(/，/gi, ',').replace(',,', ',')
            setInput(inputVal)
            const selectList = inputVal.split(',')
            onChange(selectList)
        } else {
            setInput('')
            onChange([])
        }
    }

    return (
        <div className={classNames(styles.textArea, classname)}>
            <div className={styles.beforeChunk}>
                {labelText}：<span className={styles.num}>{value.filter(item => item !== '').length}</span>
            </div>
            <TextArea
                className={styles.endChunk}
                value={input}
                autoSize={{ minRows: 1, maxRows: 3 }}
                placeholder={placeholder}
                onChange={({ target: { value: val } }) => textAreaChange(val)}
            />
        </div>
    )
})
